
import React from "react";

const DuduSection: React.FC = () => {
  return (
    <section className="section-container">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12">
        <div className="w-full md:w-1/2">
          <img
            src="/lovable-uploads/f2d82c03-7324-4443-98db-f57b5c6ab20b.png"
            alt="Dudu Crespo correndo"
            className="rounded-lg w-full"
          />
        </div>
        <div className="w-full md:w-1/2 space-y-4">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Eu sou o Dudu Crespo.</h2>
          <p className="text-lg opacity-80">
            Criador de conteúdo, empreendedor e corredor. Durante anos, procurei respostas fora — até entender que o que muda tua vida é a capacidade de construir força e presença interna.
          </p>
          <p className="text-lg opacity-80">
            A Escape nasceu pra isso: pra gente viver diferente, e não só sonhar diferente.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DuduSection;
